import { writable } from "svelte/store";
let ProductTypesStore;
export default ProductTypesStore = writable([]);
